const MarqueeText = () => {
  const text = "GreatQuality  SpecialityCoffee  •  ";

  return (
    <div className="bg-crestora-gold py-2.5 md:py-3 overflow-hidden" aria-label="Kopi spesialti berkualitas tinggi">
      <div className="flex animate-marquee whitespace-nowrap">
        {[...Array(6)].map((_, i) => (
          <span key={i} className="text-accent-foreground font-display text-lg md:text-2xl font-bold mx-4 tracking-wider uppercase" aria-hidden={i > 0}>
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default MarqueeText;
